export default __webpack_public_path__ + "static/media/schoolmakers-black.f04c5732.svg";